import Vue from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Register component globally
Vue.component('fa-icon', {
  functional: true,
  render(h, ctx) {
    const data = {
      ...ctx.data,
      class: ['fa-icon', ctx.data.class],
    };

    return h('i', data, [h(FontAwesomeIcon, ctx.data, ctx.children)]);
  },
});
